const styles = (theme: any) => ({
  acoes: {
    position: "sticky",
    bottom: 0,
    zIndex: 2,
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px 0",
    marginTop: theme.spacing(),
    background: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
    "& button": {
      marginLeft: 10
    }
  }
});

export default styles;
